import React from 'react';
import PropTypes from 'prop-types';
import Header from '../../../../components/Header';
import Image from '../../../../components/Image';
import LockBookmarkImage from '../../../../components/SubscriptionModule/Lock.svg';
import Button from '../../../../components/Button';
import '../../styles.css';

const LockedContentComponent = ({ header, subheader, body, toggleUpgradeFormVisibility }) => (
  <div styleName="content">
    <div>
      <Image src={LockBookmarkImage} aria-hidden="true" styleName="module-premium-lock" />
      <Header as="h1" styleName="content-heading">
        {header}
      </Header>
      <div styleName="intro-subheading">
        {subheader}
      </div><br /><br />
      <Button secondary styleName="upgrade-button" onClick={toggleUpgradeFormVisibility}>Upgrade</Button><br /><br /><br />
      <div styleName="intro-paragraph">
        {body}
      </div>
    </div>
  </div>
);

LockedContentComponent.propTypes = {
  header: PropTypes.string.isRequired,
  subheader: PropTypes.string.isRequired,
  body: PropTypes.element.isRequired,
  toggleUpgradeFormVisibility: PropTypes.func.isRequired,
};

export default LockedContentComponent;
